/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react';

import style from './style.module.scss';

import Modal from '../..';
import LoadingRound from '@components/loading-round/loading-round';
import Icon from '@components/icon-component';

const Info = ({
  openDownloadModal,
  setOpenDownloadModal,
  progressLoading,
  cancelDownloadingDataEvent,
  downloadingStatus,
  getUMLDataAgain
}) => {
  const [titleCount, setTitleCount] = useState(0);

  useEffect(() => {
    const titleCountTimer = setInterval(() => {
      handleTitleCountUpdate();
    }, 6000);

    return () => {
      clearInterval(titleCountTimer);
    };
  }, [titleCount]);

  const handleTitleCountUpdate = () => {
    if (titleCount >= titles.length - 1) {
      setTitleCount(0);
    } else {
      setTitleCount((prev) => prev + 1);
    }
  };

  const icon = React.useMemo(() => {
    if (downloadingStatus?.offline) return <Icon name={'sync-modal-icon'} />;
    else if (downloadingStatus?.start)
      return <LoadingRound modal={true} className={style.lottie} />;
    else if (downloadingStatus?.failed) return <Icon name={'failed'} />;
  }, [downloadingStatus]);

  const statusText = React.useMemo(() => {
    if (downloadingStatus?.offline) return <>You’re offline.</>;
    else if (downloadingStatus?.start) return <>Getting additional data</>;
    else if (downloadingStatus?.failed) return <>Download failed</>;
  }, [downloadingStatus]);

  const modalTextUpper = React.useMemo(() => {
    if (downloadingStatus?.start)
      return (
        <>
          Supplemental data, such as photos, documents and previous readings, are required for some
          inspections.
          <div className={style.progressBarContainer}>
            <progress max={3} value={progressLoading}></progress>
            <p>downloading extras</p>
            <div className={style.info} onClick={handleTitleCountUpdate}>
              <div key={titleCount}>{titles[titleCount]?.render}</div>
            </div>
          </div>
        </>
      );
    else if (downloadingStatus?.failed)
      return <>Oh no. If your internet connection isn’t solid or something else went wrong.</>;
    else if (downloadingStatus?.offline) return <>Sorry. No can do.</>;
  }, [downloadingStatus, progressLoading, titleCount, titles]);

  const modalInnerBody = React.useMemo(() => {
    if (downloadingStatus?.start)
      return (
        <div className={style.modalBtn}>
          <button
            className={`${`${style.modalBtnCancel} modal-btn-height`}`}
            onClick={cancelDownloadingDataEvent}
            disabled={false}
          >
            Cancel
          </button>
        </div>
      );
    else if (downloadingStatus?.failed)
      return (
        <div>
          <div className={style.modalBtn}>
            <button
              className="btn-fill button-large modal-btn-height"
              onClick={() => {
                getUMLDataAgain();
              }}
            >
              Retry
            </button>
          </div>
        </div>
      );
  }, [downloadingStatus, cancelDownloadingDataEvent]);

  return (
    <Modal
      open={openDownloadModal}
      // setOpen={downloadingStatus?.start ? () => {} : setOpenDownloadModal}
      setOpen={setOpenDownloadModal}
      icon={icon}
      statusText={statusText}
      modalTextUpper={modalTextUpper}
      modalImageClassName={downloadingStatus?.start && style.modalImage}
      progressDataColor={downloadingStatus?.offline && '#CBD2D9'}
      textBtn={
        downloadingStatus?.offline ? 'CLose' : downloadingStatus?.failed ? 'I’ll try later' : ''
      }
      progressData={
        downloadingStatus?.offline
          ? () => {
              return (
                <div className={style.offlineText}>
                  {' '}
                  You’ll need a stable internet connection before you can download additional data.
                </div>
              );
            }
          : null
      }
    >
      {modalInnerBody}
    </Modal>
  );
};

export default Info;

const titles = [
  {
    render: (
      <>
        <p className={style.fadeInOut}>Too much cached data can lead to performance issues.</p>
      </>
    )
  },
  {
    render: (
      <>
        <p className={style.fadeInOut}>
          That’s why you can choose to download extras in piecemeal.
        </p>
      </>
    )
  },
  {
    render: (
      <>
        <p className={style.fadeInOut}>We suggest you download this data on an as-needed basis.</p>
      </>
    )
  },
  {
    render: (
      <>
        <p className={style.fadeInOut}>Ensure you get additional data before working offline.</p>
      </>
    )
  }
];
